import { cookies } from "./modules/cookies";
import { lazyBg } from "./modules/lazy-bg";
import { lazyLoad } from "./modules/lazy-load";
import { navigation } from "./modules/navigation";
import { validation } from "./modules/validation";

function onDocumentReady() {
  cookies.init();
  lazyBg.init();
  lazyLoad.init();
  navigation.init();
  validation.init();
}
if (document.readyState !== "loading") {
  onDocumentReady(); // Or setTimeout(onReady, 0); if you want it consistently async
} else {
  document.addEventListener("DOMContentLoaded", onDocumentReady);
}
